import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[noWhitespace]',
  standalone: true,
})
export class NoWhitespaceDirective {
  private readonly ngControl = inject(NgControl, {
    self: true,
    optional: true,
  });

  @HostListener('input', ['$event'])
  protected onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\s/g, '');

    if (input.value === value) {
      return;
    }

    input.value = value;
    this.ngControl?.control?.setValue(value, { emitEvent: false });
  }
}
